<div class="linea-superior" *ngIf="value.hasParent"></div>
<div class="box-container">
  <div class="title">
    {{ value.title }}
  </div>
  <div class="info-partner" [ngClass]="value.classString">
    <i class="fa fa-user-circle-o" aria-hidden="true"></i>
    <span class="nom-agent">{{ caption | translate}}</span>
  </div>
</div>
<div class="linea-inferior" *ngIf="value.hasChild"></div>